import { render, staticRenderFns } from "./PortfolioSlider.vue?vue&type=template&id=332f7517&scoped=true&"
import script from "./PortfolioSlider.vue?vue&type=script&lang=js&"
export * from "./PortfolioSlider.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioSlider.vue?vue&type=style&index=0&id=332f7517&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332f7517",
  null
  
)

export default component.exports